// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__29VuA","dragIcon":"SortableItem_dragIcon__3J7oh","disabled":"SortableItem_disabled__1Gs1W"};